import { map, flatMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { PeopleService, LanguageService, AuthService, AuthorizationService } from '../shared/services';
import { environment } from '../../environments/environment';
import { Observable, of } from 'rxjs';
import { BaseService } from '../shared/services/baseService';
import { IndexedDbService } from '../shared/services/indexedDb.service';
import { AppConstants } from './appConstants.class';

@Injectable()
export class PermissionGuard extends BaseService {
  constructor(
    private peopleService: PeopleService,
    private router: Router,
    private language: LanguageService,
    private indexedDb: IndexedDbService,
    private authService: AuthService,
    private authorizationService: AuthorizationService
  ) {
    super();
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const routePermission: string | undefined = route.data['permission'];
    if (this.isConnection) {
      return this.activate(routePermission);
    } else {
      const currentUser = this.currentUserId;
      const applicationType = localStorage.getItem(`${AppConstants.OFFLINE_INSPECTION_APP_TYPE}_${this.currentUserId}`)
        ? localStorage.getItem(`${AppConstants.OFFLINE_INSPECTION_APP_TYPE}_${this.currentUserId}`)
        : localStorage.getItem(`${AppConstants.CURRENT_APP_TYPE}_${this.currentUserId}`);
      if (currentUser && applicationType && navigator.serviceWorker.controller.state === 'activated') {
        return this.indexedDb.openDatabase(+applicationType, currentUser).pipe(
          flatMap((res) => {
            return this.activate(routePermission);
          })
        );
      } else {
        return of(false);
      }
    }
  }

  private activate(routePermission?: string): Observable<boolean> {
    if (!this.authService.isLoggedIn()) {
      return of(false);
    }
    return this.peopleService.getCurrent().pipe(
      flatMap((data) => {
        const havePermission = routePermission
          ? this.authorizationService.isAuthorize(routePermission)
          : data.authorizations.Items.some((item: { ActionName: string }) => item.ActionName.startsWith('inspection'));
        return this.language.loadTranslations(data.language ? data.language : 'en').pipe(
          map((translation) => {
            const appRoute = environment.applicationRoute;
            return havePermission ? havePermission : this.router.navigate([appRoute, 'unauthorized']);
          })
        );
      })
    );
  }
}
